import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const tokenService = {
  async getTokens() {
    const response = await axios.get(`${API_URL}/api/auth/admin/tokens`, {
      withCredentials: true
    });
    return response.data;
  },

  async createToken(tokenData) {
    const response = await axios.post(`${API_URL}/api/auth/admin/tokens`, tokenData, {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  },

  async deleteToken(id) {
    const response = await axios.delete(`${API_URL}/api/auth/admin/tokens/${id}`, {
      withCredentials: true
    });
    return response.data;
  },

  async updateToken(id, tokenData) {
    const response = await axios.put(`${API_URL}/api/auth/admin/tokens/${id}`, tokenData, {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  }
};

export default tokenService; 